import $ from 'jquery';
import Slider, {
  attachPaginationEvents,
  cssClassLazyloadOnSlide,
  cssClassSwiperDuplicate,
  lazyLoadImage,
} from '../../js/modules/Slider.mjs';
import {gsap} from '../../js/wrapper/gsap.mjs';

const $sliders = $('.js_ef-collection-teaser-editorial');

$sliders.each((index, slider) => {
  const $slider = $(slider);
  const CollectionTeaserEditorial = new Slider({
    namespace: 'CollectionTeaserEditorial',
    sliderNode: slider,
    swiperConfigOverride: {
      autoHeight: true,
      slidesPerView: 1,
      on : {
        init() {
          // Workaround animation, when Swiper duplicates slides
          gsap.set($slider.find(`.${cssClassSwiperDuplicate} .reveal`).toArray(), {
            x: 0,
            y: 0,
            autoAlpha: 1,
          });
        },
        lazyImageLoad: lazyLoadImage,
        paginationRender(swiper) {
          attachPaginationEvents(swiper);
        },
      },
    },
  });

  if (CollectionTeaserEditorial.slidesDontFitIntoWrapper()) {
    CollectionTeaserEditorial.init();
  } else {
    $slider.find(`.${cssClassLazyloadOnSlide}`).addClass('lazyload');
  }
  CollectionTeaserEditorial.attachResize();
});
